import { createAction, props } from '@ngrx/store';
import { Terms } from 'src/app/shared/models';
import { UserDetails } from 'src/app/shared/models/portalService';

export const setUserDetails = createAction('[User Details] Set User Details', props<{ userDetails: UserDetails }>());

export const setTerms = createAction('[User Details] Set Terms', props<{ terms: Terms }>());

export const clearUserDetailsState = createAction('[User Details] Clear State');
